import { useQuery } from '@tanstack/react-query';
import api from '../api';

export const venueDataKeys = {
  all: ['venueData'],
  detail: (eventId) => ['venueData', eventId],
};

export function useVenueData(eventId, options = {}) {
  return useQuery({
    queryKey: venueDataKeys.detail(eventId),
    queryFn: async () => {
      const response = await api.get(`/venue-data/${eventId}`, { timeout: 20000 });
      return response.data;
    },
    staleTime: 30 * 60 * 1000,
    gcTime: 60 * 60 * 1000,
    enabled: !!eventId,
    ...options,
  });
}
